package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.TimerRepository

/**
 * Use case for stopping a timer.
 * Sets is_active to false in the repository.
 */
class StopTimerUseCase(
    private val timerRepository: TimerRepository
) {
    suspend operator fun invoke(
        timerId: String
    ): Result<Unit> {
        return timerRepository.stopTimer(
            timerId = timerId
        )
    }
}
